import { HelpCircle } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip'
import { Switch } from 'slab'

type EvaluateTaskStatusToggleProps = {
  checked: boolean
  onChange: (checked: boolean) => void
}

const EvaluateTaskStatusToggle = ({
  checked,
  onChange,
}: EvaluateTaskStatusToggleProps) => {
  return (
    <div className='flex items-center space-x-2'>
      <span className='font-light text-sm text-gray-500 text-nowrap'>
        Evaluate Task Status
      </span>
      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <HelpCircle className='h-4 w-4 text-gray-400 cursor-help' />
          </TooltipTrigger>
          <TooltipContent className='max-w-xs'>
            <p>
              When enabled, task execution readiness is evaluated in
              real-time (ensures tasks are immediately updated but has
              significantly worse performance). When disabled, tasks use
              cached status updated by background jobs every 15 minutes
              (much faster for list views).
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}

export default EvaluateTaskStatusToggle
